import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { ProgressSpinner } from 'primereact/progressspinner';

import { useGetPieDataScoreCardsQuery, useGetPieDataScoreCardsTierQuery } from '../../../pages/scorecardDashboard/scorecardDashboardSlice';
import { optionsChartMetrics, optionsChartMetricsTier } from './optionsChartMetrics';
import { MetricAttainmentIllustration } from '../../../components/emptyStateIllustrations/EmptyStateIllustrations';
import './AgentPieChart.scss';

interface PropTypes {
empNum?: number;
inputyear?: number;
inputmonth?: number;
scorecardVersion?: number;
}

const AgentPieChart = ({ empNum, inputyear, inputmonth, scorecardVersion }: PropTypes) => {
const [agentData, setAgentData] = useState<number[] | undefined>([]);
const [scorecardName, setScorecardName] = useState<string | undefined>('');
    const [isTierModel, setIsTierModel] = useState(false);
const [tierData, setTierData] = useState<number[]>([]);

const { data: pieChartData, isFetching: isPieFetching } = useGetPieDataScoreCardsQuery(
{
employeenumber: empNum,
year: inputyear,
    month: inputmonth,
            scorecardVersionId: scorecardVersion,
},

    { skip: !empNum }
    );

const { data: tierPieData, isFetching: isTierFetching } = useGetPieDataScoreCardsTierQuery(
{
employeenumber: empNum,
year: inputyear,
    month: inputmonth,
    scorecardVersionId: scorecardVersion,
    },
        { skip: !empNum || !isTierModel }
);

useEffect(() => {
if (pieChartData?.data?.length > 0) {
const isT = pieChartData.data[0]?.scorecard_calculation_rule_id === 2;
setIsTierModel(isT);
setScorecardName(pieChartData.data[0].scorecard_name);
if (!isT) {
setAgentData(pieChartData.data.map((item: any) => item.total_agents));
}
}
}, [pieChartData]);

useEffect(() => {
if (tierPieData?.data?.length > 0) {
setTierData(tierPieData.data.map((item: any) => item.total_agents));
}
}, [tierPieData]);

if (empNum && (isPieFetching || (isTierModel && isTierFetching))) {
    return (
        <div className="ps-0 pe-0" style={{ height: '100%', flexGrow: 1, flexBasis: 0 }}>
            <div className="card border-1" style={{ height: '100%', marginLeft: '1px', display: 'flex', flexDirection: 'column', marginBottom: '-1px', borderTop: '0px', borderRadius: '0px' }}>
                <div className="card-body pb-0" style={{ paddingTop: '5px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <div className="pieHeader">
                        <h5 className="text-center pb-0" style={{ fontWeight: '600', color: 'rgba(116, 116, 116, 1)' }}>Scorecard Attainment</h5>
                    </div>
                    <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <ProgressSpinner style={{ width: '48px', height: '48px' }} strokeWidth="4" animationDuration="0.8s" />
                    </div>
                </div>
            </div>
        </div>
    );
}

if (isTierModel && tierPieData?.data?.length > 0) {
const chartOptions: any = optionsChartMetricsTier(tierPieData.data);
return (
<div className="ps-0 pe-0" style={{ height: '100%', flexGrow: 1, flexBasis: 0 }}>
    <div className="card border-1" style={{ height: '100%', marginLeft: '1px', display: 'flex', flexDirection: 'column', marginBottom: '-1px', borderTop: '0px', borderRadius: '0px' }}>
            <div className="card-body pb-0" style={{ paddingTop: '5px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <div className="pieHeader">
                            <h5 className="text-center pb-0" style={{ fontWeight: '600', color: 'rgba(116, 116, 116, 1)' }}>Scorecard Attainment</h5>
                        <h5 className="text-center pb-0">{scorecardName}</h5>
                </div>
            <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Chart type="pie" options={chartOptions} series={tierData} width="100%" height="100%" />
        </div>
    </div>
    </div>
</div>
    );
    }

    if (!isTierModel && pieChartData?.data?.length > 0) {
        const chartOptions: any = optionsChartMetrics(pieChartData.data);
        return (
            <div className="ps-0 pe-0" style={{ height: '100%', flexGrow: 1, flexBasis: 0 }}>
                <div className="card border-1" style={{ height: '100%', marginLeft: '1px', display: 'flex', flexDirection: 'column', marginBottom: '-1px', borderTop: '0px', borderRadius: '0px' }}>
                    <div className="card-body pb-0" style={{ paddingTop: '5px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                        <div className="pieHeader">
                            <h5 className="text-center pb-0" style={{ fontWeight: '600', color: 'rgba(116, 116, 116, 1)' }}>Scorecard Attainment</h5>
                            <h5 className="text-center pb-0">{scorecardName}</h5>
                        </div>
                        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {agentData && agentData.length > 0 && (
                                <Chart type="pie" options={chartOptions} series={agentData} width="100%" height="100%" />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="agent-pie-chart-empty-wrap" style={{ flexGrow: 1, flexBasis: 0 ,backgroundColor: 'rgba(255, 255, 255, 255)' }}>
            <div className="agent-pie-chart-empty__header">Metric Attainment</div>
            <div className="agent-pie-chart-empty">
                <div className="agent-pie-chart-empty__illustration">
                    <MetricAttainmentIllustration />
                </div>
                <p className="agent-pie-chart-empty__title">No Results found for the Performance Period.</p>
            </div>
        </div>
    );
};

export default AgentPieChart;
